import { useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Button, ButtonColor, ButtonVariant } from "../Button/Button";
import { Checkbox } from "../Checkbox/Checkbox";
import { useOutsideClick } from "../Hooks/useOutsideClick";
import "./FiltersDropdown.scss";

export interface FiltersInterface {
  id: string,
  title?: string;
  filters: { id: string, name: string, on: boolean, disabled?: boolean }[];
}

interface Props {
  filters: FiltersInterface[]
  resetFilters: () => void;
  saveFilters: (filters: FiltersInterface[]) => void;
}

export function FiltersDropdown(props: Props) {
  const { saveFilters, resetFilters } = props;
  const [open, setOpen] = useState(false)
  const [filters, setFilters] = useState<FiltersInterface[]>(props.filters)
  const handleClickOutside = () => { setOpen(false) };
  const ref = useOutsideClick(handleClickOutside);

  let groups;
  let numberOfActiveFilters = 0;

  useEffect(() => {
    setFilters(props.filters)
  }, [props.filters])

  const filterChanged = (groupId: string, filterId: string, on: boolean) => {
    let newFilters = filters.map((group) => {
      if (group.id === groupId) {
        group.filters = group.filters.map((filter) => {
          if (filter.id === filterId) {
            filter.on = on;
          }
          return filter;
        })
      }
      return group;
    })
    setFilters(newFilters)
  }

  if (filters) {
    groups = filters.map((group, index) => {

      let groupFilters = group.filters.map((filter, index_2) => {
        if (filter.on) {
          numberOfActiveFilters++;
        }
        return <div className="checkboxRow" key={index + "__" + index_2}>
          <Checkbox
            checked={filter.on}
            name={filter.name}
            onCheckedChange={(checked) => {
              filterChanged(group.id, filter.id, Boolean(checked))
            }}
          />
        </div>
      })
      return <div className="filterGroup" key={index}>
        {group.title && <div className="filterGroupTitle">{group.title}</div>}
        {groupFilters}
      </div>
    })
  }
  return (
    <div className="FiltersDropdown" ref={ref}>
      <div className={numberOfActiveFilters > 0 ? "FiltersDropdownButton open" : "FiltersDropdownButton"}
        onClick={() => {
          if (!open) { setFilters(props.filters); }
          setOpen(!open)
        }}>
        <div className="FiltersDropdownButtonTitle"> {numberOfActiveFilters > 0 ? `Filter Active (${numberOfActiveFilters})` : "Filters"} </div>
        <div className="icon">{open ? <FaChevronUp /> : <FaChevronDown />}</div>
      </div>
      {open && (
        <div className="FiltersDropdownContent">
          {groups}
          <div className="FiltersDropdownOptionButtons">
            <Button variant={ButtonVariant.GHOST} onClick={resetFilters}>Reset</Button>
            <Button color={ButtonColor.ORANGE}
              onClick={() => {
                setOpen(false)
                saveFilters(filters)
              }}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
